import {ReactNode} from 'react';
import Operations from '../pages/operations';
import Users from '../pages/users';
import Checklist from '../pages/checklist';
import Forms from '../pages/forms';
import TBDScreen from '../components/common/TBDScreen';
import OnBoarding from '../pages/on-boarding';
import Organizations from '../pages/organizations';

export type RoutePermissions = {
  path: string;
  permissions: string[];
  screen: ReactNode;
  disabled: boolean;
};

const routePermissions: RoutePermissions[] = [
  {
    path: '/dashboard',
    permissions: ['manage_dashboard'],
    screen: <TBDScreen />,
    disabled: true,
  },
  {
    path: '/operations',
    permissions: ['manage_alerts'],
    screen: <Operations />,
    disabled: false,
  },
  {
    path: '/checklist',
    permissions: ['manage_checklists'],
    screen: <Checklist />,
    disabled: false,
  },
  {
    path: '/forms',
    permissions: ['manage_forms'],
    screen: <Forms />,
    disabled: false,
  },
  {
    path: '/regulations',
    permissions: ['manage_regulations'],
    screen: <TBDScreen />,
    disabled: true,
  },
  {
    path: '/employees',
    permissions: ['manage_employees'],
    screen: <TBDScreen />,
    disabled: true,
  },
  {
    path: '/equipment',
    permissions: ['manage_equipment'],
    screen: <TBDScreen />,
    disabled: true,
  },
  {
    path: '/users',
    permissions: ['manage_users'],
    screen: <Users />,
    disabled: false,
  },
  {
    path: '/suppliers',
    permissions: ['manage_suppliers'],
    screen: <TBDScreen />,
    disabled: true,
  },
  {
    path: '/organizations',
    permissions: ['manage_organization'],
    screen: <Organizations />,
    disabled: false,
  },
  {
    path: '/tutorials',
    permissions: ['manage_tutorials'],
    screen: <TBDScreen />,
    disabled: true,
  },
  {
    path: '/reports',
    permissions: ['manage_reports'],
    screen: <TBDScreen />,
    disabled: true,
  },
  {
    path: '/on-boarding',
    permissions: [],
    screen: <OnBoarding />,
    disabled: false,
  },
];

export default routePermissions;
